import { useState, useCallback } from 'react'
import { Box, Flex, VStack } from '@chakra-ui/react'
import { LuRefreshCw as RefreshCw } from 'react-icons/lu'
import { themeColors } from '../../theme'
import TrasladosActivosView from './components/TrasladosActivosView'
import { T, useT } from '../../i18n'

export default function MonitoreoTransportePage() {
  const colors = themeColors
  const { t } = useT()
  const [activeCount, setActiveCount] = useState(0)
  const [refreshKey, setRefreshKey] = useState(0)
  const [loading, setLoading] = useState(false)

  const handleActiveCountChange = useCallback((count: number) => {
    setActiveCount(count)
  }, [])

  const handleLoadingChange = useCallback((isLoading: boolean) => {
    setLoading(isLoading)
  }, [])

  const handleRefresh = useCallback(() => {
    setRefreshKey(k => k + 1)
  }, [])

  return (
    <VStack gap={6} alignItems="stretch">
      <Flex justifyContent="space-between" alignItems="center">
        <Box>
          <T tid="monitoreo.title" fontSize="2xl" fontWeight="bold" color={colors.text} />
          <T tid="monitoreo.subtitle" fontSize="xs" textTransform="uppercase" letterSpacing="0.2em" fontWeight="bold" color={colors.textMuted} mt={1} />
        </Box>
        <Flex alignItems="center" gap={3}>
          <Flex
            alignItems="center"
            gap={2}
            bg={colors.bgCard}
            px={4}
            py={2}
            borderRadius="xl"
            border="1px solid"
            borderColor={colors.border}
          >
            <T tid="monitoreo.activeVehicles" fontSize="sm" fontWeight="500" color={colors.textMuted} />
            <T fontSize="sm" fontWeight="bold" color={colors.text}>{activeCount}</T>
          </Flex>
          <Box
            as="button"
            display="flex"
            alignItems="center"
            gap={2}
            px={4}
            py={2}
            bg="transparent"
            border="1px solid"
            borderColor={colors.border}
            color={colors.text}
            borderRadius="xl"
            fontWeight="bold"
            fontSize="sm"
            cursor={loading ? 'not-allowed' : 'pointer'}
            opacity={loading ? 0.6 : 1}
            _hover={loading ? undefined : { bg: colors.bgHover }}
            transition="all 0.2s"
            onClick={loading ? undefined : handleRefresh}
            disabled={loading}
            aria-label={t('common.refresh')}
          >
            <Box as="span" display="inline-flex" style={{ animation: loading ? 'spin 1s linear infinite' : undefined }}>
              <RefreshCw size={16} />
            </Box>
            {t('common.refresh')}
          </Box>
        </Flex>
      </Flex>

      <TrasladosActivosView
        onCountChange={handleActiveCountChange}
        onLoadingChange={handleLoadingChange}
        refreshKey={refreshKey}
      />
    </VStack>
  )
}
